import PbAjax from '../../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../../base/public.pb';
import smsSendCodePb from './smssendcode.pb';
import {hex_md5} from '../../../base/md5';
import Cache from 'c-cache';

let pbajax = new PbAjax();
let cache = new Cache({
    prefix: 'pcuplive'
});
class SmsSendCode {

    constructor(data = {}) {
        this.promise = this.sendCode(data);
    }

    sendCode(data) {
        
        let self = this;
        let defer = $.Deferred();
        const { Request, Response } = smsSendCodePb.Sms.SendCode;

        let UserAgent = UP.Global.getDefaultUA();

        if (UserAgent.indexOf('feature/9999') > -1) {
            UserAgent += ' feature/9999';
        }
        
        data.deviceId = this.getCurrentUuid();
        let signature = this.getSignature(UserAgent,data.deviceId);
        data.signature = signature;
        let businessData = new Request(data);

        let requestData = {
            service: 'service',
            api: '/sms/send/code',
            header: {
                userToken: UP.Global.getUserToken(),
                'UserAgent': UserAgent,
                'Accept-Language': UP.Global.siteLanguage
            }
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                   
                    defer.resolve();
                    
                } else {
                    defer.reject();
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer;
    }
    /**生成签名串*/
    getSignature(ua,deviceId){
        /*
         S1 =设备号的aes加密后的md5后24位 （密钥为  jq5kmuqcWkrJD7M）
         S2 = （UserAgent的md5+设备号）的md5后8位。
         signature=S1+S2
         */
         let secret = 'jq5kmuqcWkrJD7M';
         let str = hex_md5( deviceId+secret );
         let s1 = str.substr(str.length - 24);
         let str2 = hex_md5(hex_md5(ua) + deviceId);
         let s2 = str2.substr(str2.length-8);

         return s1+s2;

    }

    /**
     * 模拟当前用户的身份标示
     * @param 
     * @return string
     */
    uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random()*16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }

    // 获取当前有效的uuid（有效期5分钟）
    getCurrentUuid() {
        // __ppuuid__ : uuid,timestamp
        var uuid = '';
        var old = cache.getCache('__pcuuid__');
        if (old) {
            var isExpire = this.checkExpire();

            // 若已失效
            if (isExpire) {
                uuid = this.uuid(60);
                cache.setCache('__pcuuid__' , uuid);
                cache.setCache('__pcuuid__stamp__' , +new Date);
            } else {
                uuid = old;
                this.updateValidTime();
            }
        } else {
            uuid = this.uuid(60);
            cache.setCache('__pcuuid__' , uuid);
            cache.setCache('__pcuuid__stamp__' , +new Date);
        }

        return uuid;

    }

    // 判断uuid是否失效(超过1天)
    checkExpire() {
        var stamp = cache.getCache('__pcuuid__stamp__');
        var curStamp = +new Date;
        return curStamp - Number(stamp) > 24 * 60 * 60 * 1000;
    }

    // 更新当前的有效期
    updateValidTime () {
        cache.setCache('__pcuuid__stamp__' , +new Date);
    }
    
}

export default SmsSendCode;



// WEBPACK FOOTER //
// ./js/component/phone-login/sendcode/index.js